export const FIELD_TYPES = [
    {type: "number", label: "Number", icon: "mdi-numeric"},
    {type: "text", label: "Text", icon: "mdi-form-textbox"},
    {type: "bool", label: "Bool", icon: "mdi-ab-testing"},
    {type: "date", label: "Date", icon: "mdi-calendar-today"},
    {type: "time", label: "Time", icon: "mdi-clock-time-three-outline"},
]
export default FIELD_TYPES
